export type FeatureFlagState = string[];

const initialState: FeatureFlagState = [];
// ssr only reducer, if you need it, fix it
export const featureFlagReducer = (state: FeatureFlagState = initialState): FeatureFlagState => state;
